<template>
  <div id="wcc-app" :data-calculators="calculatorsData" v-hammer:tap="commitInput" v-if="browserSupported">
    <div id="wcc-wrapper">
      <Header></Header>
      <div class="wcc calculators">
      <Calculator v-for="(calculatorData, index) in calculatorsData" :key="index" :calculatorData="calculatorData"/>
      </div>
      <Reset></Reset>
      <AddToHomescreen></AddToHomescreen>
      <Footer></Footer>
      <AppInput></AppInput>
    </div>
  </div>
  <Unsupported v-else></Unsupported>
</template>

<script>
import Header from './components/Header.vue'
import Calculator from './components/Calculator.vue'
import Reset from './components/Reset.vue'
import AddToHomescreen from './components/AddToHomescreen/AddToHomescreen.vue'
import Footer from './components/Footer.vue'
import AppInput from './components/AppInput.vue'
import Unsupported from './components/Unsupported.vue'

export default {
  name: 'app',
  methods: {
    commitInput($event) {
      if ($event.target == this.$el) {
        this.$store.dispatch('appInput/commitInput')
      }
    }
  },
  computed: {
    calculatorsData() {
      return this.$store.state.calculatorsData
    },
    browserSupported() {
      return this.$store.state.browserSupported
    }
  },
  components: {
    Header,
    Calculator,
    AppInput,
    Reset,
    AddToHomescreen,
    Footer,
    Unsupported
  }
}
</script>

<style lang="scss">
  @import './styles/styles.scss';
  #wcc-app {
    min-height: 100vh;
    #wcc-wrapper {
      max-width: $max-width;
      margin: auto;
      min-height: 100vh;
      section.wcc.section {
        border-bottom: $spacing/5 solid $grey-200;
        display: flex;
        flex-direction: column;
        position: relative;
        .wcc.content {
          margin: $spacing;
        }
      }
    }
  }
</style>
